import DashboardLayout from '../../../layouts/LayoutContainers/DashboardLayout'
import { useEffect, useState } from 'react'
import GrileService from '../../../services/grile-service.js'
import { getFullDateHourString } from '../../../utils.js'

const GrileReports = () => {
  const [reportedGrile, setReportedGrile] = useState([])
  const [showOutdated, setShowOutdated] = useState(false)

  const getUpdatedReports = grila => {
    return grila.reports.filter(
      report => report.timestamp > report.updated_timestamp,
    )
  }

  const isOutdated = report => {
    return report.timestamp <= report.updated_timestamp
  }

  useEffect(() => {
    GrileService.getReports().then(reports => {
      const grileReports = {}

      for (const report of reports) {
        if (report.grila_id in grileReports) {
          grileReports[report.grila_id].push(report)
        } else {
          grileReports[report.grila_id] = [report]
        }
      }

      const t = []
      for (const [grila_id, reports] of Object.entries(grileReports)) {
        reports.sort((a, b) => b.timestamp - a.timestamp)

        t.push({
          grila_id,
          reports,
        })
      }
      t.sort(
        (a, b) => getUpdatedReports(b).length - getUpdatedReports(a).length,
      )

      setReportedGrile(t)
    })
  }, [])

  return (
    <DashboardLayout style={{ position: 'absolute' }}>
      Arata reporturile outdated
      <input
        type="checkbox"
        checked={showOutdated}
        onChange={() => setShowOutdated(!showOutdated)}
      />
      {reportedGrile.map(grila => (
        <div
          key={`grila-${grila.grila_id}`}
          style={{
            borderStyle: 'solid',
            borderWidth: '2px;',
            padding: '10px',
            margin: '10px',
          }}
        >
          <div
            style={{
              borderStyle: 'solid',
              borderWidth: '2px;',
              padding: '10px',
              margin: '10px',
            }}
          >
            Grila id: {grila.grila_id}; Last update:{' '}
            {getFullDateHourString(
              new Date(grila.reports[0].updated_timestamp * 1000),
            )}
            ; Reports after last update: {getUpdatedReports(grila).length} (
            {grila.reports.length} total reports)
          </div>
          {grila.reports
            .filter(report => showOutdated || !isOutdated(report))
            .map(report => (
              <div
                key={`report-${report.id}`}
                style={{
                  borderStyle: 'solid',
                  borderWidth: '2px;',
                  padding: '10px',
                  margin: '10px',
                  color: isOutdated(report) ? '#cccccc' : 'black',
                }}
              >
                {isOutdated(report) && 'Outdated'}
                <div>
                  By: {report.email} (id: {report.user_id}){' '}
                  {getFullDateHourString(new Date(report.timestamp * 1000))}
                </div>
                <div>Reasons: {report.reasons || 'None'}</div>
                {report.descriptions.map(description => (
                  <div key={`description-${description}`}>{description}</div>
                ))}
              </div>
            ))}
        </div>
      ))}
    </DashboardLayout>
  )
}
export default GrileReports
